<script setup>
import { ref, defineProps, defineModel } from 'vue' //, defineEmits
import moment from 'moment';

const showingPicker = ref(false)
const dateFormatted = defineModel()
const date = ref(null)
const crtProps = defineProps(['label', 'style', 'class', 'variant', 'density', 'hideDetails'])

function updateDate(value) {
    
    let localFormat = moment.localeData(navigator.language).longDateFormat('l')
    dateFormatted.value = moment(value).format(localFormat)
    showingPicker.value = false
}

const crtVarian = !crtProps.variant ? 'solo' : crtProps.variant
const crtDensity = !crtProps.density ? 'compact' : crtProps.density
const crtHideDetails = crtProps.hideDetails == undefined ? true : crtProps.hideDetails

</script>

<template>
    <div :class="crtProps.class">
        <v-text-field :label="crtProps.label" 
            autocomplete="one-time-code"
            :variant="crtVarian" 
            :density="crtDensity" 
            v-model="dateFormatted"
            :hide-details="crtHideDetails" >
            <v-menu v-model="showingPicker" 
                :close-on-content-click="false" 
                activator="parent">
                <v-card>
                    <v-card-title>
                        <v-btn icon="mdi-close" density="compact" variant="text" @click="showingPicker = false" ></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-date-picker v-model="date" 
                            no-title
                            @update:model-value="updateDate" >
                        </v-date-picker>
                    </v-card-text>
                </v-card>
            </v-menu>
        </v-text-field>
    </div>
</template>